module.exports = __webpack_public_path__ + "img/pdf-icon.d187c177.svg";